import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu } from '../../services/nav.service';
import { OappService } from '../../services/oapp.service'
import { NetsolinService } from '../../services/netsolin.service';
import { NetsolinService as NetService } from '../../services/netsolin.service';

//Modelo
import { MenuItems } from '../../../administracion/menuItems'
import { CustomizerService } from '../../services/customizer.service';
import { SidebarService } from '../../services/sidebar.service';
import { ErpService } from '../../services/erp.service';
import { NetsolinApp } from '../../global';
import { DomSanitizer } from '@angular/platform-browser';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-user-sidebar',
  templateUrl: './user-sidebar.component.html',
  styleUrls: ['./user-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserSidebarComponent {

  //erp
  public ano = "2022";
  public periodo = "1";
  public dia = "1";
  public moduloSel = 0;
  public iterano = [0, 1, 2, 3, 4];
  public itermes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public cargoerp = false;
  public menu = {
    monitores: [],
    reportes: [],
    personalizados: [],
    procesos: [],
  }
  selected = "monitores"

  //formulario
  loadingForm = false;
  titleForm;
  htmlForm;

  texterror: any;
  error: boolean;
  linkseditseg;

  rutaBase = "/assets/svg/law.svg"

  constructor(
    public erpS: ErpService,
    public sidebarS: SidebarService,
    private router: Router,
    public navServices: NavService,
    private netsolinService: NetsolinService,
    private netService: NetService,
    private sanitizer: DomSanitizer,
    public customize: CustomizerService) {
    this.sidebarS.instruccionS.subscribe(instruction => {
      if(sidebarS.vista="documento"){
        this.handleDocumentos(instruction);
      }
    })
    var fechacto = new Date();
    this.ano = fechacto.getFullYear().toString();
    this.cargarModuloMenu();
    this.cargoerp = true;
  }

  //ERP

  private cargarModuloMenu() {
    let icons=[
      'statistic-up',
      'document',
      'settings-ui'
    ]
    this.netsolinService.getModulosWebSolinNetsolin().then((res: any) => {
      var monitores = [];
      var reportes = [];
      var procesos = [];
      for (let modulo of res.modulos) {
        var link = decodeURI(encodeURIComponent(this.formatLink(modulo.info_deta)));
        var objmenweb = {
          text: modulo.nombre,
          desc: modulo.info_gen,
          link: link,
          per:false
        };
        if (modulo.codigo.indexOf('PER') != -1) {//ES UN PERSONALIZADO
          objmenweb.per=true
        };
        if (modulo.codigo.indexOf('MON') != -1) {//ES UN MONITOR
          monitores.push({
            ...objmenweb,
            icon: `/assets/svg/${modulo.grafico ? modulo.grafico:icons[0]}.svg`,
          });
        }
        else if (modulo.codigo.indexOf('REP') != -1) {//ES UN REPORTE
          reportes.push({
            ...objmenweb,
            icon: `/assets/svg/${modulo.grafico ? modulo.grafico : icons[1]}.svg`,
          })
        }
        else if (modulo.codigo.indexOf('PRO') != -1) {//ES UN PROCESO
          procesos.push({
            ...objmenweb,
            icon: `/assets/svg/${modulo.grafico ? modulo.grafico : icons[2]}.svg`,
          });
        };
      }
      this.menu.reportes = reportes;
      this.menu.procesos = procesos;
      this.menu.monitores = monitores;
      console.log("Modulos web cargados.", this.menu.reportes);
    });
  }
  private formatLink(link) {//Formatear los links de NETSOLIN y Llena variables como PVXIANO, PVXIPERIODO
    link = link.replace('[ano]', this.ano);
    link = link.replace('[periodo]', this.periodo);
    return link;
  }
  trigger(tipo, modulo) {
    console.log('Trigger Modulo',tipo, modulo);

    if (tipo == 'procesos' || tipo == 'reportes') {
      this.sidebarS.vista = "formulario"
      this.loadingForm = true;
      this.titleForm = modulo.text
      this.ejecutaObjeto(decodeURIComponent(modulo.link))
    }
    else if(tipo == "parametros"){
      this.sidebarS.postInstructionP({
        tipo: 'table',
        tab: 2,
        objeto: modulo.cod_obj,
        modulo:modulo.modulo,
      })
      this.router.navigate([modulo.path]);
      this.sidebarS.collapseUserSidebar()
    }
    else {
      this.sidebarS.postInstructionP({
        tipo: 'tabExec',
        tab: 1,
        link: modulo.link
      })
      this.sidebarS.collapseUserSidebar()
    }
  }

  //Documentos

  documentoMsg(type,id){
    this.sidebarS.postInstructionP({
      tipo: type==0?"modificar":"eliminar",
      id:id
    })
  }
  handleDocumentos(inst){
    if (inst.type=='ruta'){
      console.log('haga algo llamado desde componetne');
    }

  }
  //Formulario

  ejecutaObjeto(link, redirect?) {
    NetsolinApp.objenvrest.tiporet = "CON";
    this.netService.getNetsolinObjconLink(link).toPromise()
      .then((result: any) => {
        console.log("Resultado llamado netsolin sidebar", result);
        if (redirect) {
          this.goBack();
          this.sidebarS.postInstructionP({
            tipo: 'tab',
            tab: 5
          })
          this.sidebarS.collapseUserSidebar()
        }
        else {
          console.log(result.html);

          if (typeof result.isCallbackError === "undefined" || !result.isCallbackError) {
            this.htmlForm = this.sanitizer.bypassSecurityTrustHtml(result.html || result.resultado);
            this.linkseditseg = result.link_editarobj+' '+result.link_seguridadobj;
            this.addScript(result.js_generado)
            this.loadingForm = false
            this.texterror = [];
            this.error = false;
          } else {
            console.log(result);
            this.loadingForm = false
            this.texterror = result.messages;
            this.linkseditseg = result.link_edseg;
            this.error = true;
          }
        }
      },
        error => {
          console.log("Error en ejecutaObjeto2 ");
          console.log(error);
        }
      );

  }
  addScript(js_generado) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = '';
    script.setAttribute("id", "netsolin-js");
    let old = document.getElementById("netsolin-js")

    script.text = js_generado;
    script.async = true;
    script.defer = true;
    if (old) {
      document.body.replaceChild(script, old);
    }
    else {
      document.body.appendChild(script)
    }  }
  goBack() {
    this.sidebarS.vista = "erp"
  }

  processLinks(e) {
    const ele: any = e.target;
    const id: any = e.target.id;

    if (id == 'Fboton') {
      e.preventDefault();
      const link = e.view.LLINKREFRE.substr(8);
      console.log('link', link);
      this.ejecutaObjeto(link, true)
    }
    else if (id == 'cancelar') {
      this.goBack()
    }
  }

}
